module.exports = {
  animals: {
    page_title: '動物資料庫',
    choose_your_language: '請選擇你的語言',
    determine: '確定',
    noData: '敬請期待',
    do_you_know: '你知道嗎',
    scientific_name: '學名',
    family: '科',
    diet: '飲食',
    food: '食物',
    habitat: '棲息地',
    location: '分佈區域',
    group_name: '綱',
    lifespan: '壽命',
    classification: '分類',
    date_of_naming: '命名日期',
    order: '目',
    weight: '重量',
    size: '尺寸',
    top_speed: '最高速度',
    endangered_level: '瀕危程度',
    fossils_discovered: '發現化石',
    species: '物種',
  },
  btnText: {
    request: '請求失敗！',
    delete: '刪除',
    deleteInfo: '刪除與否？',
    signout: '登出',
    signoutInfo: '登出？',
    loginSuccess: '登陸成功！',
    regSuccess: '註冊成功',
    emailExist: '郵箱已存在',
    activaSuccess: '已成功激活',

    delCart: '您確定要刪除此產品嗎？',
    confirm: '確認',
    cancel: '取消',
    tip: '提示',

    setSuccess: '設置成功',
    addSuccess: '添加成功',
    editSuccess: '編輯成功',
    delSuccess: '刪除成功',
  },
  top: {
    animalsBucket: '桶裝動物模型',
    animalsBox: '動物模型套裝',
    animalsPuzzle: '動物拼圖',
    others: '其他',
    sales: '優惠產品',
    sale: '促銷',
    animal: '動物資料庫',
    collections: '探索 Wenno 玩具系列',
    product: '產品',
    shop: '所有產品',
    about: '品牌故事',
    downloadApp: '下載應用程式',
    blog: '博客',
    btn: '立即購買',
    selRegion: '選擇地區',
    contentTip: '搜索',
    followUs: '關注我們',
    dinosaurs: '恐龍系列',
    wildAnimals: '野生系列',
    farmAnimals: '農場系列',
    oceanAnimals: '海洋系列',
    dinosaursKeyword: '恐龍',
    wildAnimalsKeyword: '野生',
    farmAnimalsKeyword: '農場',
    oceanAnimalsKeyword: '海洋',
  },
  footbar: {
    f1: '免費送貨',
    f1info: '訂單金額超過$200.00HKD',
    f2: '輕鬆學習',
    f2info: '豐富語言和動物知識',
    f3: '關愛地球',
    f3info: '促進環保意識',
    f4: '安全環保',
    f4info: '由無毒和可回收材料製成',
    signup: '註冊',
    footer: 'Wenno通訊以接收我們的最新消息。',
    input: '輸入您的電子郵件',
    about: '關於我們',
    privacy: '私隱條款',
    terms: '服務條款',
    shipping: '送貨服務',
    contact: '聯絡我們',
    subscribe: '電子訂閱',
    btnSubscribe: '訂閱電子報',
  },
  dialog: {
    login: '登錄',
    logIn: '登錄',
    signup: '註冊',
    loginOrSignup: '登錄/注冊',
    cart: '購物車',
    phoneNumber: '聯係電話',
    accountNo: '賬號',
    loginEmail: '郵箱登錄',
    loginPhone: '用手機號碼登錄',
    registerSuccess: '註冊成功,激活郵件已經發至您的郵箱,請注意查收',

    name: '名稱',
    email: '電子郵件地址',
    pass: '密碼',
    cpass: '確認密碼',

    code: '驗證碼',
    char: '輸入6個字符或更多',

    forgot: '忘記密碼？',
    deng: '登錄',
    reg: '注冊',
    sub: '提交',
    guest: '作為客人購買',
    newsletterCheck: '讓我們變得更親近！ 我們只會向您傳送好東西。',
    agreeTerms: 'By creating your account, you agree to our terms and conditions & privacy policy',
    forgotTitle: '忘記密碼',
    account: '還沒有帳號嗎？',
    signWith: '註冊',
    google: '谷歌',
    face: '臉書',

    pname: '請輸入你的名字',
    pemail: '請輸入您的電子郵件',
    pvemail: '請輸入有效電子郵件',
    ppass: '請輸入密碼',
    p6pass: '密碼必須至少6位數字',
    pcpass: '請再次輸入密碼',
    ptpass: '兩次輸入的密碼不一致！',
    pcode: '請輸入驗證碼',
    pselect: '請選擇',
    pselectinfo: '請選擇區號',
    pphone: '請輸入您的聯係電話',
    warn: '繼續創建您的賬戶，表示您同意我們的',
    terms: '條款及細則',

    phoneVerification: '手機驗證',
    codeTo: '驗證碼已發送至',
    checkCode: '請查閲您的訊息以取得4位數的驗證碼,并於下方輸入',
    sendAgain: '重新發送驗證碼',
  },
  product: {
    productline: '產品線',
    ancient: '古代',
    sea: '海洋',
    land: '陸地',
    ar: '虛擬實境 (AR)',
    arinfo: '不只是動物！通過互動遊戲探索Wenno AR！',
    whyar: 'Wenno和AR？',
    whyarl: '玩Wenno動物玩具是一個有趣，富教育性和互動性的學習體驗。',
    whyarr: '與手機應用程序配合，顯示不同動物的資料。',
    whyarerr: '您的瀏覽器不支持此短片',

    detail: '產品詳情',
    addcart: '添加到購物車',
    details: '產品詳情',
    bestSeller: '暢銷產品',
  },
  index: {
    freeDeliveryBar: '消費滿港幣$200可免基本運費。(香港地區）',
    how: 'Wenno如何運作？',
    howtitle1: '虛擬實境',
    howinfo1: '使用Wenno手機程式，您可以隨時隨地進行遊戲！我們在每個包裝盒中提供的遊戲卡上印有QR碼。通過將這些卡片與移動設備連接，可以顯示有關每隻動物的更多詳細信息，例如動物的棲息地，生活環境和有趣的事實。同時可以培養幼兒的環保意識。',
    howtitle2: '英語學習',
    howinfo2: '這不僅僅是一套玩具。我們精美的非洲動物模型不止令人印象深刻，配合手機使用，它們會變得更多功能！套裝隨附小型遊戲卡-只需將Wenno應用程序下載到您的iOS或Android設備上，然後掃描遊戲卡即可。每個型號都有對應的遊戲卡，可在您的手機上顯示有趣的動物事實，資料和互動信息！可以盡情玩耍之餘，也可以學英語！',
    howtitle3: '動物模型',
    howinfo3: '基於我們現代世界的7大洲和5大洋。我們還引用了瀕危和滅絕的動物，以及最受歡迎的中生代恐龍、傳統野生動物、農場動物和海洋生物系列中。',
    why: '為什麼選擇Wenno？',
    whytitle1: '好玩',
    whyinfo1: '我們提供的材料可以讓小朋友動手製作和進行遊戲！',
    whytitle2: '方便',
    whyinfo2: '您只需要：移動設備，Wenno產品和說明書，即可展開您的奇妙旅程！',
    whytitle3: '教育性',
    whyinfo3: '資深教育心理學家推薦Wenno®應用程式和產品，「這是一種非常有用的親子工具，提供超過100多種詳細的動物資訊」。',
    review1: '物超所值！',
    reviewname1: '- Thomas',
    review2: '最好的玩具！',
    reviewname2: '- Anne',
    review3: '買到上癮！',
    reviewname3: '- Sharon',
  },
  shop: {
    all: '全部',
    categories: '類別',
    sort: '排序方式',
    new: '新品',
    pricehl: '價格從高到低',
    pricelh: '價格從低到高',
    popular: '最受歡迎',
    buy: '立即購買',
    noData: '暫無數據',
    inventory: '庫存',
    pieces: '件',
    noSku: '該商品暫無商品規格',
    plsku: '請先選擇商品規格',
    payCodeExp: 'payCode已過期，支付碼不再是可掃描的，請點擊刷新payCode重新支付',
    payCodeErr: 'payCode獲取失敗，請重新下單或者在訂單詳情頁面選擇其他方式支付',
    filter: '排序方式',
    dinosaur: '恐龍',
    wildAnimals: '野生動物',
    farmAnimals: '農場動物',
    oceanAnimals: '海洋動物',
    guessYouLikeIt: '猜你喜歡',
  },
  cart: {
    shop: '購物車',
    detail: '詳情',
    qty: '數量',
    price: '價錢',
    total: '總價：',
    checkout: '結算',
    back: '返回',
    empty: '購物車是空的。',
    goshopp: '去逛逛',
    coupon: '優惠券號碼：',
    sure: '確定',
    remark: '請輸入備註',
    selectAdd: '請選擇收貨地址',

    ship: '運費',
    free: '免費',
    charge: '收費',
    freexin: '訂單滿$200.00HKD免運費',
    code: '優惠券',
    grand: '累計',

    pcoupon: '請輸入優惠券碼！',
    country: '國家/地區',
    addaddress: '新增地址',
    sf: 'SF儲物櫃',
    checkOut: '結算',
    shipInfo: '訂單信息',
    goback: '返回',
    continue: '繼續支付',
    payment: '付款',
    paySuccess: '支付成功',
    payFail: '支付失敗',
    continueShop: '繼續購物',

    pregion: '請選擇國家/地區',
    preceiver: '請輸入收貨人',
    paddress1: '請輸入地址1',
    pphone: '請輸入電話',
    pphone1: '請輸入正確的電話',
  },
  about: {
    about: '關於',
    info1: '小朋友眼中，動物就是他們的好伴侶。Wenno® 以此為出發點，多年來一直用心設計以小朋友為中心的動物模型，陪伴著他們成長，一同創造無數歡樂回憶並引導他們愉快地學習。\n\n我們深信，只要堅持信念並盡心設計，定必能為動物教具賦予更大意義，真正做到「More than just animals」。',
    info2: 'Wenno®️的創立，是始於我作為三孩父母的一種體會：我們相信玩具的作用不應只是用來消磨時間，而是應該具教育意義，讓小孩能「從遊戲中學習」。\n\n只要小朋友能投入遊戲當中，自然能培養出自主學習興趣，啟發創意及多角度思考，過程中更可學習到不同知識和技能。於是，我們在1995年決定於香港成立 ，逐步以行動將想法實踐，成為了一切的起步點。',
    info3: 'Wenno®️於2015年正式面世，延續着我們的初衷，秉持「FUN & LEARN」的原則，透過研發不同賦有教育意義的益智教具，激發小朋友對 STREAM 的興趣，從小發掘他們多方面潛能，同時灌輸愛護動物和保護地球觀念。\n\n近年我們更為這種傳統塑膠動物模型注入科技元素，包括AR小遊戲，手機應用程式及全息投影等，透過更多互動讓小朋友投入玩耍過程，豐富他們的生活。',
    info4: '我們明白家長對兒童產品安全性和品質必定有相當高要求，因此 Wenno®️ 的產品符合 EN71 和 ASTM 國際標準，並已通過 ISO9001 認證，以確保我們的產品質量保持高水準，讓家長和小朋友都能玩得放心。同時我們絕對支持並嚴格遵守國際玩具業委員會商業行為準則（ICTI）的原則及要求。\n\n由於我們產品質量佳、耐用度高，即使小朋友長大後亦可以將玩具轉贈予更加年幼的小朋友，甚至捐贈給有需要的人，讓Wenno®️的意義延續，為更多小朋友帶來快樂。',
    info5: 'Wenno®️ 慶幸得到各家長支持和小朋友喜愛，不斷持續發展，現已在全球建立了分銷、批發、零售、以及線上銷售，成功發展至擁有自己的生產線及銷售渠道。\n\n自我們成立以來，Wenno®️ 一直由家族管理和經營，希望將我們愛家庭的熱情轉化至業務中，一起邁向 Wenno®️ 的成功願景。',
    info6: '為所有家庭提供安全和能負擔的產品，是Wenno®️一直以來的使命，期望讓家長在沒有規限情況下給小孩盡情玩耍和學習。而為了讓大眾能更方便地將Wenno®️產品帶回家，我們現已更新網頁系統，並以嶄新面貌提供一站式簡易購物服務。\n\n通過我們多年努力與堅持，我們希望更多家庭能親身體會到Wenno®️動物特別的意義，將「FUN & LEARN」意念融入生活，不論是為小朋友挑選禮物，還是想入手親子遊戲玩具時，都能第一時間想起我們，同時想起Wenno®️的宗旨——「More than just animals」。',
    since1: '(自2008年起)',
    text1: 'ICTI是負責玩具和兒童產品的供應鏈計劃。透過合乎道德的玩具生產，為工人創造更美好的生活和建立更強大的行業。',
    since2: '(自2015年起)',
    text2: 'ISO14006（環境管理系統）是一項國際標準，它規定了一些準則，以幫助我們建立、記錄、實施、保持和持續改善我們的生態設計管理，並將其作為環境管理系統的一部分。',
    since3: '(自2016年起)',
    text3: '商界社會責任倡議行為守則（BSCI）是領先的供應鏈管理系統，可支持我們在全球供應鏈的工廠內推動社會責任和改進。BSCI實施保護勞工權利的國際勞工標準原則，例如國際勞工組織（ILO）的公約和宣言，聯合國（UN）工商企業與人權指導原則，以及經濟合作暨發展組織的跨國企業指引（OECD）。',
    since4: '香港Q嘜優質產品計劃（自2015年起）',
    text4: '香港Q嘜優質產品計劃是一項產品認證計劃，公司在香港，中國大陸或澳門設有生產工廠。計劃旨在為那些公司提供有效的質素管理體系，以生產出始終如一的優質產品。',
    since5: '香港D嘜認證計劃（自2019年）',
    text5: '「香港D嘜認證計劃」，簡稱「D-Mark」，旨在表彰那些已經建立了有效利用質量設計框架的公司。D嘜認可公司為追求卓越設計所做的努力，在公司中樹立的設計和創造力文化。',
    since6: '香港傑出服務（2020）',
    text6: '香港傑出服務是一項獨立的認證計劃，以確保在各個客戶服務領域提供優質的服務。通過顧客問卷、神秘顧客和管理系統檢查，對服務提供商進行評估。',
    since7: 'Intertek STEM玩具驗證計劃（自2019年）',
    text7: '一個獨特且值得信賴的標誌，可為玩具製造商在整個供應鏈中提供全面質量保證，並向教育機構和消費者保證STEM學習玩具已達到最高質量和安全標準。',
    since8: '優質品牌（2019）',
    text8: '優質品牌支持具有社會責任感和環保理念的高品質和信譽良好的公司，為客戶和社會創造價值，以建設一個可持續發展，繁榮的香港。',
    text9: '香港星級玩具大獎2018, 由am730 x mameshare頒發 ',
    text10: '香港工商業獎：睿智生產力獎是對通過精心計劃和執行得當的生產力計劃，而獲得競爭優勢的香港公司或組織的認可。獲獎者必須證明自己的生產力不斷得到顯著的提高。',
  },
  account: {
    bank: '滙豐銀行',
    bankname: '銀行名稱',
    accountnumber: '戶口號碼',
    accountname: '戶口名稱',
    phonenumber: '電話號碼',
    paypalmessage: '通過 PayPal 付款',
    fpsID: 'FPS ID',
    account: '我的帳戶',
    orderTrack: '訂單與追踪',
    prefer: '偏好',
    logot: '登出',
    paytip: '付款方式：',
    accountD: '賬戶詳情',
    personal: '個人資料',
    name: '名稱：',
    email: '電郵：',
    pass: '密碼：',
    passBtn: '更改密碼',
    lang: '語言',
    oldpass: '原密碼',
    newpass: '新密碼',
    conpass: '確認密碼',

    ppass: '請輸入舊密碼',

    edit: '編輯',
    add: '添加',
    sub: '提交',

    // paymentMethod: '支付方式',
    addressBook: '地址簿',
    paymentMethod: '支付方式',
    shippAddress: '帳單/送貨地址',
    consignee: '收貨人',
    address: '地址',
    operate: '操作',

    receiver: '收貨人',
    phone: '電話',
    company: '公司（可選）',
    region: '地區',
    address1: '地址1',
    address2: '地址2',
    emailadd: '電子郵件',
    area: '大區',
    district: '小區',
    search: '搜索',

    receiverR: '收貨人為必填項',
    phoneR: '電話為必填項',
    regionR: '地區為必填項',
    address1R: '地址1為必填項',

    subscre: '訂閱',
    SubscribeNew: '訂閱新聞信息',
  },
  blog: {
    blog: '博客',
    detail: '博客資訊',
  },
  order: {
    detail: '訂單詳情',
    list: '訂單',
    info: '產品詳情',
    price: '單價',
    qty: '數量',
    tprice: '總價',
    status: '狀態',
    operate: '操作',
    check: '查看訂單',
    name: '收貨人',
    phone: '電話',
    shippAddress: '收貨地址',
    orderNote: '備注',
    orderNo: '訂單號',
    logstatus: '物流狀態',
    logInfo: '物流信息',
    logDetail: '物流詳情',
    total: '總價',
    orderStatus: '訂單狀態',
    refund: '退款',
    paid: '已支付',
    close: '已關閉',
    approving: '審核中',
    unpaid: '未支付',
    readyToShip: '有待出貨',
    receiptRejected: '收據被拒絕',
    confirmReceipt: '確認收貨',
    receipt: '收據',
    totalpieces: '共 {amount} 件',
    empty: '空白',
    productDeleted: '商品過期不存在',
    uploadBtn: '上傳轉賬憑證',
    uploadTip: '請先上傳憑證',
    uploadTip1: '上傳圖片只能是 JPG GIF PNG JPEG 格式!',
    uploadTip2: '上傳圖片大小不能超過 2MB!',
    uploadSuc: '上傳憑證成功，等待審核結果',
    uploadErr: '上傳憑證失敗',
  },
  footer: {
    info: '使用本網站即表示您接受WENNO網站的',
    tc: '條款及細則',
    title: '此等條款及條件構成 　閣下與我們之間具法律約束力之協議。閣下確認及同意此等條款及條件適用於閣下進入及使用本網站以及透過本網站提供之服務。閣下進入或使用本網站或使用服務，即表示閣下已閱讀及明白此等條款及條件以及同意受其約束。',
    infotitle1: '1.  私隱聲明',
    info1: '我們的私隱聲明載於本網站並適用於閣下以及閣下使用本網站及服務。',
    infotitle2: '2.  條款及條件之修訂',
    info2: '我們保留不時修訂此等條款及條件之權利。任何修訂於本網站 發佈通知後即告生效。閣下於發佈通知後繼續使用本網站及服務即表示閣下同意受經修訂之條款及條件所約束。',
    infotitle3: '3.  帳戶',
    info3: '閣下如欲於本網站購買產品，可以建立一個帳戶並填妥我們要求的所有資料。閣下必須為每個帳戶設立密碼，以及可聯絡閣下的有效登入電郵地址。閣下有責任將閣下之密碼保密。此外，閣下須為閣下或使用閣下登入電郵地址之任何其他人士之任何及全部活動負責。閣下可按照本網站之指示隨時更改閣下之密碼。建立帳戶及使用服務須符合以下條件： (a) 閣下有能力訂立有法律約束力之合約；(b) 閣下持有有效電郵地址；及(c) 閣下並非以任何其他人士的受託人身份行事。',
    infotitle4: '4.  訂單',
    info4: '任何透過本網站進行的產品訂購，為閣下於訂購時以該等產品之價格（連同所有適用運費及稅項）購買該等產品之要約。若我們就任何訂單提出要求，閣下必須向我們提供任何額外詳情及／或確認閣下之詳情 。閣下透過本網站進行訂購時，必須向我們提供完整及準確的資料。閣下在本網站訂購產品時有責任遵守所有適用法律 （包括任何最低年齡規定）。我們或會行使絕對酌情權拒絕閣下之訂單（包括但不限於訂單內的任何產品缺貨、如本網站內的產品價格或描述有錯漏或無法就訂單進行付款）。如我們拒絕閣下之訂單，我們將盡力於合理時間內通知閣下。我們會就每項我們接納的訂單向閣下發出確認電郵。我們可於以下情況隨時取消全部或任何部分之訂單（包括我們已接納的任何訂單）而無須向閣下承擔責任：(a) 訂單內的任何產品缺貨；(b) 本網站內就訂單內任何產品之價格或描述有錯漏；(c) 我們合理地相信閣下違反本協議之任何條款或條件；或 (d) 無法就訂單進行付款。若我們取消任何訂單，我們將盡力向閣下提供合理通知。我們不會就我們所取消的訂單的任何部份向閣下收費。',
    infotitle5: '5.  送貨',
    info5: '閣下同意遵守我們於本網站所載之所有派送規定（包括但不限於任何派送地點限制）。我們或會就若干產品聯絡閣下以作出派送安排。我們僅會於有人在派送地址進行接收時派送閣下訂購之產品。我們或會要求接收閣下所訂產品的人士向我們出示身份證明及／或訂購時付款所用的信用卡（如適用）。如無人在派送地址接收閣下訂購之產品，我們將盡力聯絡閣下，閣下或可聯絡我們，以安排於另一時間派送。我們可能就再派送閣下訂購之產品向閣下收取額外派送費用。閣下確認及同意在派送地址收取所訂購商品的任何人士皆獲閣下授權收取閣下訂購之產品 。在本網站訂購產品的風險及所訂購產品的所有權於派送至閣下的派送地址時即轉移至閣下。',
    infotitle6: '6.  退貨',
    info6: '所有在本網站訂購的產品之退貨均受我們為本網站所訂立的退貨政策所規限。',
    infotitle7: '7.  費用及收費',
    info7: '我們將向閣下收取而閣下同意支付於本網站訂購的每件產品之價格連同所有運費及稅項，以及此等條款及條件中所載之任何其他費用及收費。產品之價格於閣下進行訂購時顯示於本網站，並且包含商品服務稅。產品之價格不時變動。在此等條款及條件規限下，我們一旦接納閣下之訂單，我們將不會變更訂單內產品之任何價格。 同一件產品之價格或有別於我們任何門巿內之價格，而且我們沒有義務配合我們門巿或任何第三者之任何定價。',
    infotitle8: '8.  付款',
    info8: '所有付款均由安全伺服器進行，且作為保安措施每宗交易均會加密，以及所有付款均只能以港幣進行。閣下可使用PayPal來支付獲接納之訂單。倘我們未能成功處理閣下訂單之付款，我們或會拒絕或取消閣下之訂單。若閣下選擇以信用卡付款，即代表閣下授權我們從閣下指定信用卡中扣除獲接納訂單應付之金額。閣下不得透過任何欺詐或非法途徑為產品付款或試圖付款。',
    infotitle9: '9.  服務',
    info9: '我們不聲明或保證我們的網站或服務將不受干擾或零錯處或零缺陷。我們不向閣下聲明或保證透過本網站或服務取得的任何電子檔案將不存在有害代碼。',
    infotitle10: '10.  保安',
    info10: '閣下確認儘管我們一方已採取所有合理措施，閣下透過閣下的電腦系統或本網站所傳送的數據或資料，仍存在被人擅自取用或更改的風險。在法律允許的最大範圍內，我們不會就該等行為引致閣下或閣下因此蒙受之任何損失承擔責任。',
    infotitle11: '11.  服務之更改',
    info11: '我們保留於我們認為必需或適當時就服務作出任何更改之權利。我們將盡所有合理努力於本網站預先通知該等更改，唯閣下確認並非所有更改皆可以預先通知（包括但不限於為補救本網站之錯處或缺陷而作出之任何緊急且必要之更改）。',
    infotitle12: '12.  合法使用',
    info12: '閣下必須僅為合法目的使用本網站及服務，並確保閣下進入或使用本網站及服務並非不合法或受法律禁止。閣下有責任於使用本網站及服務時遵守所有適用法律。閣下同意於任何時間處理透過本網站提供或取得的任何資料或材料時，以遵守香港或任何其他相關司法管轄區所有適用法律的方式進行。',
    infotitle13: '13. 不當使用資料',
    info13: '閣下不得以任何方式不當使用本網站或任何於本網站發佈的材料（包括但不限於以任何方式修改、複印、複製、再版、上載、發佈、傳送或分發任何材料的全部或任何部分，除非獲此等條款及條件明確許可，或於正常使用服務下可合理預計的情況）。閣下不得干擾或破壞（或意圖干擾或破壞）任何與本網站連接的伺服器或網絡。',
    infotitle14: '14.  本網站資訊',
    info14: '我們不會就閣下擬使用的本網站內任何資訊之準確性、完整性或適當性作出保證或聲明。　閣下須就使用從本網站取得的任何資訊承擔責任。閣下應親自作出查詢以核實本網站之資訊對閣下的預期用途而言是否準確、完整及適當。材料內所有資訊僅屬一般性質且並無構成專業意見的意圖。本網站或載有包含其他人士觀點或建議的資訊，其不一定代表我們的觀點。本網站載有第三方維護之互聯網網站之連結及標示。該等第三方網站之連結為便利　閣下而提供。該等連結並不由我們控制，且我們不對任何連結網站或連結網站內包含的任何連結之內容（包括對閣下的預期用途而言的準確性、完整性或適當性）承擔責任。我們不認可該等連結網站內任何資訊或任何關連組織、產品或服務。',
    infotitle15: '15.  免責聲明',
    info15: '在法律允許的最大範圍內，我們不會就(a) 閣下取用或使用服務、本網站、任何材料或任何連結網站；(b) 閣下依賴任何材料作出的任何決定或行動；(c) 本網站或服務任何錯處或缺陷；或(d) 任何產品訂單所引起或與之有關連而不論是閣下引致（包括基於我們的疏忽）、蒙受或招致之任何損失（包括利潤損失或間接、相應、附帶、特殊、懲戒性或懲罰性損失或損害）承擔責任。上述免責聲明並非試圖或意圖免除某程度上不能合法地免除的任何法定責任。',
    infotitle16: '16.  法定保證',
    info16: '在法律允許的最大範圍內，我們在任何擔保、條件或保證（包括但不限於就可銷售性、可接受品質、用途適用性或已知效果適用性之任何擔保、條件或保證）之下或任何法例或基於任何法例隱含於本協議（法定保證）之下任何其他權利或補救之責任特此免除。當我們須承擔任何法定保證下之責任時，以及任何法例廢止或禁止合約內含有排除或修改法定保證之應用或行使或項下責任之條款時，我們就任何違反該等法定保證而承擔的責任應限於由我們選擇的以下一項或多項：(a)如違反涉及貨品：更換貨品或供應同等貨品；維修該等貨品；更換貨品或獲得同等貨品的成本；或維修貨品的成本；及(b)如違反與服務有關：再次提供服務或再次提供服務的成本。閣下確認及同意我們所依賴的此等責任限制於所有情況下屬公平及合理。',
    infotitle17: '17.  不可抗力',
    info17: '我們不就任何延誤或無法履行我們在本協議下的義務承擔責任，如該等延誤或不遵從乃由於超越我們合理控制的情況而引起。',
    infotitle18: '18.  彌償',
    info18: '閣下同意彌償及持續彌償WENNO INTERNATIONAL LIMITED、其人員、僱員及代理（獲彌償者）所蒙受或招致之所有損失，而該等損失與(a) 閣下於本協議下任何義務或保證的任何違反；(b) 閣下任何故意不當行為；或(c) 閣下任何疏忽行為或遺漏有關。',
    infotitle19: '19.  版權',
    info19: '材料（包括但不限於文字、圖像、標誌、圖標、聲音紀錄及軟件）的所有版權由WENNO INTERNATIONAL LIMITED及其特許人擁有。由第三方取得的材料或涉及該第三方持有的版權。除明確授權並受版權法案下規定之條件所規限，或獲此等條款及條件明確許可或因正常使用服務所合理預期外，於未獲得我們或（材料屬第三方所有之情況下）材料版權持有人明確書面許可下，閣下不得以任何形式或任何方式：(a) 將全部或任何部分材料複印、改編、複製、儲存、分發、列印、展示、表演、刊發、向公眾傳達、向公眾提供或制作衍生作品；或(b) 將全部或任何部分材料商業化。',
    infotitle20: '20.  商標',
    info20: '本網站使用之商標乃屬WENNO INTERNATIONAL LIMITED之商標或註冊商標。倘閣下使用任何我們的商標提述我們、本網站或服務，閣下必須包含一段商標乃屬於我們的聲明。閣下不得在以下情況下使用任何我們的商標：(a) 於閣下本身之商標內或作為閣下本身之商標的全部或部分；(b)與並非屬於我們的任何業務、產品或服務有關；(c)一定程度上可能對其他人士構成混淆、誤導或欺騙；或(d)一定程度上貶低我們、材料或本網站。',
    infotitle21: '21.  公開發表',
    info21: '閣下不得於未獲我們事先書面許可下向公眾發佈任何有關我們的新聞公告、廣告材料、宣傳材料或任何其他形式的宣傳。',
    infotitle22: '22.  終止',
    info22: '倘閣下違反此等條款及條件之任何條文，我們可終止本協議、閣下於本網站建立的任何帳戶以及閣下進入本網站。我們可無須提供理由而運用酌情權終止本協議、 閣下於本網站建立的任何帳戶以及閣下進入本網站之所有或任何部分。終止本協議將不會令本協議終結後仍然有效的條文終結。',
    infotitle23: '23.  一般條文',
    info23: '倘我們於某情況下放棄我們於本協議下全部或部分的任何權利，這不代表該等權利於任何其他情況下將自動被放棄。倘本協議任何條文基於任何原因被判定為無效、不能執行或不合法，則退而求其次解讀至給予最大可能之效力，或倘其不能被賦予任何效力，則與本協議分割，從而使本協議餘下部分仍然繼續有充分效力。本協議將受香港法律約束。',
    infotitle24: '24.  釋義',
    info24: '於此等條款及條件內，除文義另有所指外：',

    h1: '協議',
    p1: '指閣下與我們之間包含此等條款及條件之協議。',
    h2: '適用法律',
    p2: '指不時生效並與閣下使用、進入本網站及服務有關之任何及全部法規、規則、細則、條例或附屬法例。',
    h3: '派送費用',
    p3: '指派送閣下訂購產品之費用。每張訂單的費用將取決於所訂購產品的淨購買金額及種類（尤其是產品的尺寸及重量）。',
    h4: '有害代碼',
    p4: '指直接或間接有害或導致失效，或有助或能夠導致未獲授權取用或損壞數據的任何電腦病毒、木馬程式、蠕蟲病毒或其他電腦編碼。',
    h5: '損失',
    p5: '指任何種類的任何損失或損害，包括但不限於對第三方負有的責任。',
    h6: '材料',
    p6: '指我們透過本網站提供的任何內容（包括但不限於資訊、數據、文件、圖像、相片、圖形、聲音、影像或網絡廣播）。產品指本網站內宣傳的每件產品。',
    h7: '服務',
    p7: '指我們透過本網站向閣下供應產品及提供相關服務。',
    h8: '本網站',
    p8: '指我們營運的https://www.wennoanimal.com/website/#/Index網站',
    h9: '稅項',
    p9: '指與本協議下任何產品或任何交易有關的所有稅項、徵稅、徵費及收費。',
    h10: '我們、我們的',
    p10: '指WENNO INTERNATIONAL LIMITED。',
    h11: '閣下、閣下的',
    p11: '指使用本網站的任何人士。',
  },
  lion: {
    top1: '活動',
    top2: '解説指引',
    top3: '學習重點',
    title: '一家團聚的獅子',
    active: '引導孩子透過動物拼圖認識獅子的世界裏有雄性獅子，雌性獅子和幼獅子，究竟他們各自有什麽角色。',
    list1: '請大家留意非洲大草原有什麽動物，表示原來有獅子家族',
    list2: '思考獅子爸爸和獅子媽媽在這家族裏扮演著怎樣的角色。雌性獅子大多擔任捕獵食物的角色及照顧幼獅子',
    list3: '而獅子爸爸則是一家之主，能保護一家的安全',
    list4: '透過幼獅子被受父母照顧的畫面，讓孩子也能聯想到自己也受著爸爸媽媽的照顧。以此讓孩子從獅子一家聯想到自己的家庭，記起父母對自己的呵護和付出',
    list5: '同一時間，引導孩子思考在家裏兄弟姐妹是否有互相關愛，與家人融洽地相',
    learn: '引導孩子明白每個成員在家庭中都有著不同的角色，分工合作，讓大家學懂一家融洽相處的重要性，並教導孩子的成長之道，助他們在成長的道路上有最好的表現，健康快樂地往前進發。',
  },
  bear: {
    title: '能夠面對逆境的大灰熊',
    active: '家長引導孩子在動物拼圖活動中認識大灰熊如何經歷春、夏、秋、冬的四個季節，究竟牠們有怎麽樣的難題及生活方式。',
    list1: '棲息於北美洲的大灰熊，於一年四季都要以不同方式生活',
    list2: '每當春天來臨時，大灰熊會慢慢從冬眠中甦醒過來',
    list3: '大灰熊迎接炎熱的夏天並進行覓食，會在這個產卵的季節於河流大量捕捉三文魚',
    list4: '當秋季到來時，因爲河流中的魚兒會逐漸減少，大灰熊便會在樹林中尋找野果充飢',
    list5: '最後，當寒冷的冬季到來時，大灰熊會尋找合適的洞穴進行冬眠休息，並靜待明年春天的到來',
    learn: '引領孩子明白人生必定會遇到逆境，每當寒冬過後便會有春天的到來，冬必逢春。勇敢面對逆境後便會有溫暖而美麗的春天到來。',
  },
  penguin: {
    title: '帝皇企鵝的父愛與母愛',
    active: '家長可引導孩子使用動物拼圖，學會細心觀察和認識企鵝爸爸與媽媽在孕育企鵝成長時所肩負的重任。',
    list1: '棲息於南極的帝皇企鵝媽媽,生命中身負懷孕的重大責任',
    list2: '當她誕下企鵝蛋後，便必須回到海裏捕獵食物以補充體力',
    list3: '這時，企鵝爸爸需要使用雙腳，承托及夾緊企鵝蛋',
    list4: '企鵝爸爸用自己的身體來保護並孵化小企鵝，還要在媽媽歸來前抵受寒冷的天氣和飢餓',
    list5: '經過孵化後，企鵝寶寶終於出生了',
    list6: '這時企鵝媽媽還未回來，企鵝爸爸需要用喉嚨中腺體的分泌物餵養他們',
    list7: '最終，企鵝媽媽帶著獵物回來時，企鵝爸爸便會和媽媽交換角色，出海覓食。',
    learn: '從以上的孕育故事，孩子可學懂父愛和母愛同樣偉大，而且得悉父母養育孩子並不容易，從而讓他們懂得感激父母養育之恩。',
  },
  sunfish: {
    title: '外型奇特的翻車魚',
    active: '透過動物拼圖，家長能夠教導孩子世界上有種類繁多的魚類牠們各有特質，並認識他們各自以怎麽的方法在海裏前進。',
    list1: '一般的魚類主要靠尾鰭及左右兩側的魚鰭前後擺動作爲前進的方式',
    list2: '但魔鬼魚有別於一般魚類，他們前進方式主要靠身體左右兩側上下擺動',
    list3: '外貌奇特的翻車魚前進方式更为奇特，他們缺乏一般魚類的尾鰭',
    list4: '左右魚鰭亦細小得與身體不成比例，因此牠的上下魚鰭特別發達，以左右搖擺作爲前進方式',
    list5: '由此可見，魚類都會因應自己的身體特性發展出各式各樣的活動形態及生活方式',
    learn: '令孩子從中明白不同人都擁有不同的短處和長處，繼而教導孩子接受自己的個人特質，尋找適合自己的發展方向，盡展所長，各適其式。',
  },
  shinghing: {
    tab1: '關於我們',
    tab2: '聯繫我們',
    tab3: '免責條款',
    tab4: '成就與獎項',

    aboutInfo1: '公司簡介',
    aboutInfo2: '成興塑膠製品有限公司成立於 1995 年，主要業務包括設計及製造塑膠動物玩具。',
    aboutInfo3: '成興塑膠製品有限公司成立於 1995 年，主要業務包括設計及製造塑膠動物玩具。近年透過引入新型 PVC 注射技術，以及向 ODM 及 OBM 轉型 發展，為市場提供各類極具價格競爭能力的塑膠動物產品。',
    aboutInfo4: '睿智生產力成就',
    aboutInfo5: '2020+ 成興智能工廠',
    aboutInfo6: '成興管理層一直鼓勵不同的項目和計劃，推動業務發展和提升生產力。2016 年自行制定及提出「2020+ 成興智能工廠」，成為行業內OBM企業實施工業 4.0 的先鋒。在工業 4.0 的概念和基礎下，成興建立起由塑膠化合物至成品的綜 合生產線，並從三方面實現其智能工廠計劃，包括:',
    aboutInfo7: '垂直整合:',
    aboutInfo8: '引入 ERP、MES、APS 及無紙化運作，將日常營運及生產數 據全面數碼化',
    aboutInfo9: '橫向集成:',
    aboutInfo10: '原材料生產水平數據化，並與全球化工原料增塑劑供應商連 接，更準確地控制及預測材料用量及庫存數據',
    aboutInfo11: '合適的生產自動化:',
    aboutInfo12: '引入六軸自動化設備、優化及整合模具的設計及生產 程序，降低勞動力成本',
    aboutInfo13: '項目讓成興日常營運更為數碼化，包括可實行數碼化績效管理，對生產狀況進 行即時的糾正及預防措施，同時能更有效地進行原材料庫存管理，減低風險。',
    aboutInfo14: '自主品牌及授權業務',
    aboutInfo15: '自 2000 年起，成興通過發展自主品牌“維亮 (Wenno)”和“動物世界 (Animal World)”，成功向 ODM 及 OBM 業務轉型。透過與世界知名品牌「國家地理」 合作，成興成為 PVC 仿真動物玩具的全球授權商，由設計、製造、分銷至零 售，涵蓋整個業務鏈。同時，成興利用自身的設計及生產能力，對這些品牌產 品組件實施了標準化，從實現規模效益。',
    aboutInfo16: '雖然歐美市場在過去數年表現不穩，但在有效的品牌管理下，項目的淨利潤、 成品價值以及毛利率均有穩定增長，“維亮 (Wenno)”更於 2015 年獲得香港 Q 嘜優質產品認證。成興同時取得了BSCI、ICTI、ISO 9001和ISO 14006等多 項認證，所有產品均符合 EN71 和 ASTM 標準或相關分銷國家特定安全標準。',

    contactInfo1: '香港辦公室和陳列室',
    contactInfo2: '聯繫人︰吳先生',
    contactInfo3: '香港九龍尖沙咀東部麼地道67號半島中心11樓1106室',
    contactInfo4: '(852) 2464 8378',
    contactInfo5: 'info@shtoys.com.hk',
    contactInfo6: '(852) 2463 6704',
    contactInfo7: '展覽會',
    contactInfo8: '我們每年都會參加一些世界著名的博覽會，即香港玩具和遊戲博覽會，Spielwarenmesse（紐倫堡國際玩具博覽會）。 如果您想在展會期間與我們預約，請隨時給我們發電子郵件info@shtoys.com.hk。',
    contactInfo9: '我們期待與您會面！',
    contactInfo10: '電子目錄',
    contactInfo11: '我們的產品目錄現在可用。 展示我們所有安全且優質的塑料動物雕像，包括我們的自家品牌Wenno和授權品牌Animal Planet。',
    contactInfo12: '單擊下面的下載電子版本（PDF格式）。 或者，請與我們聯繫以將復印件交付給您。',
    contactInfo13: '*請注意，您將需要免費的Adobe Reader來查看目錄的PDF版本。',
    contactInfo14: '下載',

    termsInfo1: '下載任何文件即表示您接受以下條款和條件：',
    termsInfo2: 'Wenno™的版權由成興塑料製造有限公司（成興）擁有；其他版權可能由其他方持有。未經版權所有者的明確書面許可，嚴禁複製，修改，改編或以任何形式使用圖像或信息。任何用途（包括但不限於復制，插圖以及與成興公司擁有版權有關的任何其他用途）都需要正式請求，並且必須以書面形式提出並發送至我們的聯繫電子郵件。',
    termsInfo3: '本文提供的信息是按“原樣”和“可用”提供的。成興對於通過http://www.shtoys.com.hk或通過http://www.shtoys.com.hk獲得的信息和數據不提供任何明示或暗示的保證，包括所有隱含的保證和條件或適銷性，質量或特定用途的適用性，所有權和非侵權性，並且不對目錄中包含的信息的準確性做任何陳述。網站和這些目錄中的材料以及用戶對它們的訪問可能會有所更改，恕不另行通知。',
    termsInfo4: '成興，包括其高級管理人員，董事會成員和代理人，對任何形式的損害或損失，包括但不限於因使用本文中提供的信息或材料而產生或與之相關的損害或損失，不承擔任何責任；或因依賴本文提供的任何信息或材料的準確性或及時性而產生；或因查看，分發或複製本文提供的任何信息或材料而產生或與之相關。',
    termsInfo5: '成興所有作品©2019成興塑料製造有限公司。保留所有權利。',

    awardsInfo1: '香港優質服務（2020）',
    awardsInfo2: '優質服務計劃是一項獨立的認證計劃，以確保在各個客戶服務領域提供優質的服務。可以通過“客戶調查”，“神秘購物者”和“管理系統檢查”程序對服務提供商進行評估。',
    awardsInfo3: '香港D標誌（自2019年）',
    awardsInfo4: '“香港D-Mark認證計劃”，簡稱“ D-Mark”，旨在表彰那些已經建立了有效利用質量設計框架的公司。馬克認可公司為追求卓越設計，在公司中樹立設計和創造文化而做出的努力。',
    awardsInfo5: 'Intertek STEM玩具商標驗證計劃（自2019年）',
    awardsInfo6: '一個獨特且值得信賴的標誌，可為玩具製造商在整個供應鏈中提供全面質量保證，並向教育機構和消費者保證STEM學習玩具已達到最高的質量和安全標準。',
    awardsInfo7: '優質品牌（2019）',
    awardsInfo8: '優質品牌支持具有社會責任感和環保理念的高品質和信譽良好的公司，為客戶和社會創造價值，以建設一個可持續發展，繁榮的香港。',
    awardsInfo9: 'am730 x mameshare（2018）頒發的“最佳教育玩具品牌”玩具獎，2018年',
    awardsInfo10: '成興：2018年香港工商業獎的智慧生產力獎（2018）',
    awardsInfo11: '香港工業獎：智慧生產力是對那些通過精心策劃和執行的生產力計劃獲得競爭優勢的香港公司或組織的認可。獲獎者必須不斷證明其生產力得到了顯著提高。',
    awardsInfo12: '首席執行官吳Cal文先生：2018年香港創新技術與製造業聯合會新一代獎（2018年）',
    awardsInfo13: '“新一代”成就獎旨在表彰獲獎者在研發，創新和他們在企業發展中所取得的成就方面所做的努力。',
    awardsInfo14: 'BSCI（企業社會合規倡議）合規（自2016年起）',
    awardsInfo15: '商業社會責任合規倡議（BSCI）是領先的供應鏈管理系統，支持我們在全球供應鏈的工廠內推動社會責任合規和改進。 BSCI實施保護勞工權利的國際勞工標準原則，例如國際勞工組織（ILO）的公約和宣言，聯合國（UN）商業與人權指導原則以及經濟合作組織和跨國公司的準則。發展（OECD）。',
    awardsInfo16: '香港Q標誌產品計劃（自2015年起）',
    awardsInfo17: '香港Q標誌產品計劃是一項產品認證計劃，公司在香港，中國大陸或澳門設有生產工廠。該計劃旨在為那些公司提供有效的質量管理體系，以生產出質量穩定的產品。',
    awardsInfo18: '合併ISO14006環境管理體系（自2015年）',
    awardsInfo19: 'ISO14006是環境管理系統，是一項國際標準，它指定了一些準則，以幫助我們建立，記錄，實施，維護和持續改善我們的生態設計管理，作為環境管理體系的一部分。',
    awardsInfo20: 'GSV（全球安全驗證）認證（自2012年起）',
    awardsInfo21: '全球安全驗證（GSV）標準是Intertek制定的一項計劃，旨在根據國際供應鏈安全要求幫助進口商和供應商評估其安全措施',
    awardsInfo22: 'ICTI CARE基金會合規性（自2008年起）',
    awardsInfo23: 'ICTI是負責玩具和兒童產品的供應鏈計劃。我們的使命是通過合乎道德的玩俱生產，為勞動者創造更美好的生活，並為更強大的行業服務。',
    awardsInfo24: 'ISO9000質量管理體系認證（自2000年起）',
    awardsInfo25: 'ISO 9000被定義為一組有關質量管理和質量保證的國際標準，旨在幫助公司有效地記錄保持有效質量體系所需的質量體係要素。',
  },
  collections: {
    title1: 'Wenno動物紙盒套裝系列',
    title2: 'Wenno動物桶裝系列',
    title3: 'Wenno動物拼圖遊戲系列',
    subtitle1: '以逼真的動物模型 打開小朋友的想像世界',
    subtitle2: '實現孩子夢想中的「動物國度」',
    subtitle3: '一盒玩具3種玩法  多方面發掘小朋友潛能',
    info1: 'Wenno動物紙盒套裝系列——絕對是孩子展現創意的最好工具！一盒附有多款逼真的動物模型，呈現出最真實的動物形態，令孩子們能瞬間投入到動物世界裡，透過角色扮演開展自己的探險之旅。\n\n不管是陸上、海洋的刺激歷險，還是穿梭時空勇闖神秘的恐龍世界，Wenno動物模型都會是孩子最好的夥伴，而他們亦能透過遊戲更了解動物的特徵習性、棲息地等，無形間激發他們主動學習。立即給小朋友送上這份最好的禮物，激發一場場有趣的冒險旅程！\n',
    info2: '要將家變成夢想中的動物國度？有Wenno動物桶裝系列就隨時都可以！我們不單止為孩子設計出最逼真、精緻的動物模型，就連場景也為小冒險家預備好，多款動物模型及場景配件會陪伴孩子們遊遍七大洲五大洋，經歷意想不到的有趣故事，爸爸媽媽們千萬不要低估孩子的創造力，放手讓他們作主，打造屬於他們的動物大世界，從旁引導他們去主動學習，透過遊戲提高對動物的認知。\n\n每套裝均附有蓋圓桶，收納動物模型方便之餘，更可培養小朋友自行收拾玩具的良好習慣。\n',
    info3: '最好的玩具，就是夠「好玩」、「耐玩」，且能引導孩子從中學習。Wenno動物拼圖遊戲系列便將最好的集合起來，讓孩子能與逼真的動物模型玩角色扮演之餘，可同時挑戰3級不同難度的動物拼圖，甚至加入AR互動遊戲與各位小冒險家鬥智鬥力，令探索動物世界變得前所未有地新奇有趣！\n\n透過遊戲，小朋友能了解動物的特徵習性、棲息地等，激發他們主動學習，而玩拼圖更是培養孩子專注力、手眼協調及邏輯思維的大好方法。從今天起，不妨與孩子一起投入遊戲當中，真正寓教於樂！\n',
  },
  privacy: {
    content: `
      <h3>我們收集什麼樣的信息？</h3>
      <p>我們收集您的信息，當您在我們的網站上註冊，下定單，訂閱我們的資訊，或者回應的一項調查顯示。</p>
      <p>訂貨時或在我們的網站上註冊，在適當情況下，你可能會被要求輸入您的姓名，電子郵件地址，郵寄地址，電 話號碼或信用卡信息。不過，您可以匿名訪問我們的網站。</p>
      <h3>我們如何使用您的信息嗎？</h3>
      <p>我們向您收集的任何信息，可以使用以下方式之一：</p>
      <p>要個性化你的經驗（您的信息有助於我們更好地響應您的個性化需求）</p>
      <p>為了提高我們的網站（我們不斷努力提高我們的網站產品的基礎上，我們收到你的信息和反饋）</p>
      <p>為了提高客戶服務（您的信息有助於我們更有效地響應客戶服務請求和支持需求）</p>
      <p>要處理交易（你的信息，不論是公共或私人的，不會被出售，交換，轉讓，或以任何理由，任何其他公司未經 用戶同意，除提供所購買的產品或服務要求的明確目的。）</p>
      <p>方便我們提供優惠，調查或改善其他網站功能</p>
      <p>定期發送電子郵件（您提供的電子郵件地址，訂單處理，只會被用來向您發送信息和更新有關您的訂單。）</p>
      <h3>我們如何保護您的信息？</h3>
      <p>我們實施各種安全措施，保持您的個人信息的安全性，當你把一個命令或輸入，提交或訪問您的個人信息。</p>
      <p>我們提供一個安全的服務器使用。提供的所有敏感/信用信息是通過 SSL技術，然後到我們的支付網關供應商數 據庫加密傳輸只能夠訪問這種系統具有特殊訪問權限授權，並須保持信息的機密。</p>
      <p>交易後，你的私人信息（信用卡，安全號碼，財務等）將不會被存儲在我們的服務器上。</p>
      <h3>我們使用cookies？</h3>
      <p>（Cookies是一個網站或其服務提供者傳輸到您的電腦硬盤驅動器通過您的Web瀏覽器（如果你允許的話）， 使站點或服務供應商系統確認您的瀏覽器和捕捉並記憶某些信息的小文件</p>
      <p>我們使用cookie來幫助我們記住並處理您的購物車中的物品。</p>
      <h3>我們向外界透露任何信息？</h3>
      <p>我們不會出售，交易，或以其他方式轉讓向外界您的個人身份信息。這不包括受信任的第三方協助我們經營我 們的網站，開展我們的業務，或為您服務，只要各方同意保持這些信息的保密。我們也可以釋放你的信息時， 我們認為是適當的釋放遵守法律，執行我們的網站政策，或保護我們或他人的權利，財產或安全。然而，非個 人身份識別訪客信息可以提供給其他方，市場營銷，廣告或其他用途。</p>
      <h3>第三方鏈接</h3>
      <p>有時候，我們在網站，可能會提供第三方的產品或服務。這些第三方網站有單獨的和獨立的隱私政策。因此， 我們沒有責任或義務，這些鏈接網站的內容和活動。儘管如此，我們力圖保護的完整性我們的網站，並歡迎任 何反饋這些網站。</p>
      <h3>符合加州在線隱私權保護法案</h3>
      <p>因為我們重視您的隱私，我們已經採取了必要的預防措施，以符合加州在線隱私權保護法案。因此，我們不會 未經您的同意向外界分發您的個人信息。</p>
      <h3>符合兒童在線隱私保護法案</h3>
      <p>我們遵守COPPA（兒童在線隱私保護法案）的要求，我們不收集任何未滿13歲人士的資料。我們的網站、產品 和服務對象都是至少13歲或以上的人。</p>
      <h3>僅線上隱私權保護政策</h3>
      <p>本在線隱私政策僅適用於通過我們網站收集的信息，而不是離線收集的信息。</p>
      <h3>付款安全</h3>
      <p>聯款通是領先的，安全可靠的國際支付服務供應商的銀行和網上商戶自2000年以來客戶的付款細節正在使用
      256位的擴展驗證證書（安全地傳輸到收單銀行，卡和支付公司進行實時交易授權EV）SSL加密交易。聯款通支
      持CVV / CVC檢查，以及Visa和MasterCard即3-D安全認證：VISA驗證，萬事達卡安全為客戶和商戶加入安全 保護。</p>
      <h3>條款和條件</h3>
      <p>也請訪問我們的<a href="#/T&C">條款和條件以及免責聲明</a></p>
      <h3>您的同意</h3>
      <p>通過使用我們的網站，您同意我們的在線隱私政策。</p>
      <h3>我們的隱私政策的更改</h3>
      <p>如果我們決定改變我們的隱私政策，我們將發布於此頁面上和更新隱私政策的修改日期。</p>
      <h3>查閱和改正</h3>
      <p>您可以隨時要求查閱、復印，並要求我們修改，或要求我們停止繼續收集、處理和使用，或刪除您儲存在我們記錄的個人資料。如您想行使您的權利，請電郵致
        <a href="mailto:info@shtoys.com.hk">info@shtoys.com.hk</a>與我們聯絡。</p>
`,
  },
  contactUs: {
    content: `
      <h3>客戶服務:</h3>
      <p>電郵： <a href="mailto:info@shtoys.com.hk">info@shtoys.com.hk</a></p>
      <p>地址： 九龍尖沙咀麼地道67號半島中心1106室</p>
      <h3>開放時間：09:00-18:00</h3>
      <p style="color: red">**不設零售及購物，請於網站購買</p>
`,
  },
  deliveryService: {
    content: `
      <h3>我們可送貨到哪裡？</h3>
      <p>Wenno  Shop所售賣的商品僅限於香港提供送貨服務， 和不設退貨或退款服務</p>
      <p>一般送貨服務不包括香港的禁區範圍或汽車需要特別通行證方可抵達之地區(如：西貢黃石碼頭)、
      香港國際機場(赤鱲角)及離島 (如: 大嶼山 (東涌、愉景灣及馬灣除外)
      、坪洲、長洲、南丫島、蒲台島)。</p>
      <p>未能提供送貨服務到以下地點：社區治療設施、社區隔離設施、社區隔離酒店。</p>
      <h3>運費及預計送貨時間 (網店購物)</h3>
      <p>Wenno Shop使用不同快遞組合，以確保送貨速度快，價格實惠，免費送貨或一般送貨服務預
      計送貨時間約 3-7 個工作天。送貨公司於送貨當天致電客人確認。所有送貨單必須簽名。請確
      保有人於閣下提供的送貨地址簽收作實。</p>
      <p>運費是根據訂單金額（實價）計算。訂單金額（實價）超過HK$200可獲得免費標準送貨服務</p>

      <table>
        <tbody>
          <tr>
            <td class="blue" colspan="2">訂單金額（實價）</td>
            <td class="blue">(運費HK$)</td>
          </tr>
          <tr>
            <td class="blue">由</td>
            <td>至</td>
            <td rowspan="2">$50</td>
          </tr>
          <tr>
            <td class="blue">$1</td>
            <td>$199</td>
          </tr>
          <tr>
            <td class="blue" colspan="2">$200或以上</td>
            <td class="blue">免費</td>
          </tr>
        </tbody>
      </table>

      <p>電梯未能直達送貨之地址，司機將盡可能駛至地址最近的停車處交收
      (例如：唐樓或村屋或獨立屋在地下/停車場/村公所/牌方交收)。顧客須繳付「送貨服務公司額外費用」
      (不設退款)，並需將費用以現金方式於到貨時繳付給送貨員。</p>
      <h3>受疫情影響下的特別送貨安排</h3>
      <p>基於現時新型冠狀病毒疫情最新發展，我們會盡力處理及派送所有訂單。
      惟部份訂單或需要較長時間方可送達，希望顧客能夠體諒。</p>
      <p>為保障顧客及員工的安全，我們的送貨服務將有特別安排。</p>
      <p>部份訂單會因應個別大廈情況及大廈管理人員的指示，安排貨物放於門外、
      在大廈地下大堂交收或由管理處代收。送遞公司人員會在送遞前聯絡顧客作出安排。</p>
      <p>如果送貨地址所處大廈屬「群組感染個案大廈」或被政府納入「受限區域」，有關訂單或會延遲派送，
      我們會確保地區安全及許可進入後安排送貨。</p>
`,
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh-TW.js